/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Cases_Timeline_IncidentInputs */

const en_cases_timeline_incident = /** @type {(inputs: Cases_Timeline_IncidentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Incident: ${i?.date}`)
};

const pt_br2_cases_timeline_incident = /** @type {(inputs: Cases_Timeline_IncidentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sinistro: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Incident: {date}" |
*
* @param {Cases_Timeline_IncidentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_timeline_incident = /** @type {((inputs: Cases_Timeline_IncidentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Timeline_IncidentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_timeline_incident(inputs)
	return pt_br2_cases_timeline_incident(inputs)
});